import fetchUtils from '../utils/fetchUtils';

const getDataProfile = async () => {
  try {
    const response = await fetchUtils.get(`/profile`, {
      token: true,
      isOldGateway: true,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export { getDataProfile };
